import { Injectable } from '@angular/core';
import { Company } from '../class/Company';
import { ApiService } from './api.service';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class SiteListService extends BaseService<Array<Company>> {
  public constructor(apiService: ApiService) {
    super(apiService);
  }

  public override HandleResponse(response: JSON): Array<Company> {
    const companyList = new Array<Company>();
    const companyBack = response['read']['data'];

    for (const a in companyBack) {
      const company = new Company(companyBack[a]);
      companyList.push(company);
    }

    return companyList;
  }
}
